import { getWindow } from "@faire/web/common/globals/getWindow";
import React, { CSSProperties, forwardRef } from "react";

import { isFirefox } from "@faire/retailer/lib/user-agent/isFirefox";

/**
 * @Todd So this is supposed to fix a bug with how firefox renders img tags before they are mounted,
 * in firefox it renders the alt text before showing the image, and we want to hide that
 * except for when its a google bot because otherwise you will see a flash of alt text while its loading
 * and it looks bad
 */

const hiddenAltText = (backgroundColor = "white"): CSSProperties =>
  isFirefox() && !getWindow()?.isRobot
    ? {
        color: backgroundColor,
        backgroundColor,
      }
    : {};

interface IProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  placeholderColor?: string;
}

export const Image = forwardRef<HTMLImageElement, IProps>(
  ({ placeholderColor, style, ...rest }, ref) => {
    const { backgroundColor, ...restStyle } = style ?? {};

    return (
      <img
        {...rest}
        style={{
          ...hiddenAltText(backgroundColor ?? placeholderColor),
          ...restStyle,
        }}
        ref={ref}
      />
    );
  }
);
